import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ExportacaoDialogData {
  totalPagina: number;
  totalRegistros: number;
}

export interface ExportacaoDialogResult {
  tipo: 'pagina' | 'todos';
  formato: 'xlsx' | 'csv';
}

@Component({
  selector: 'app-exportacao-dialog',
  templateUrl: './exportacao-dialog.component.html',
  styleUrls: ['./exportacao-dialog.component.scss'],
})
export class ExportacaoDialogComponent {
  tipoExportacao: 'pagina' | 'todos' = 'todos';
  formatoExportacao: 'xlsx' | 'csv' = 'xlsx';

  constructor(
    public dialogRef: MatDialogRef<ExportacaoDialogComponent, ExportacaoDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ExportacaoDialogData
  ) {}

  onCancelar(): void {
    this.dialogRef.close();
  }

  onConfirmar(): void {
    this.dialogRef.close({
      tipo: this.tipoExportacao,
      formato: this.formatoExportacao,
    });
  }
}
